export enum TOP_UP_TRACKING {
  NOT_ENOUGH_CREDITS_MODAL = 'Not Enough Credits Modal',
  NOT_ENOUGH_CREDITS_FOOTER = 'Not Enough Credits Footer',
  GENERATE_PLAN_MODAL = 'Generate Plan Modal',
  GENERATE_PREMIUM_PLAN_MODAL = 'Generate Premium Plan Modal',
  TOP_UP_BUTTON = 'Top Up Button',
  TOP_UP_LINK = 'Promo Link',
}
